<template>
  <v-container>
    <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
      <v-btn v-on:click="save" outlined large color="indigo"><span class="black--text subtitle-1">Speichern</span>
      </v-btn>
    </div>
    <div class="my-3">
      <h1 class="uiTitle header">
        Berechnungsergebnisse
      </h1>
      <h2 class="smallHeader">
        {{ $t('mietspiegel.title') }}
      </h2>
    </div>

    <!-- Content -->
    <div class="ui-grid-a">
      <div class="ui-block-a">

        <h3 class="berechnungsContent">Ihre Angaben:</h3><br/>
        <ul>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/wohnflaeche'" class="berechnungsLink">Wohnfläche:</a>
            {{ berechnung.wohnflaeche }} m²
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/baujahr'" class="berechnungsLink">Baujahr:</a>
            {{ $t('baujahr.' + berechnung.selectedBaujahr) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/wohnlage'" class="berechnungsLink">Wohnlage:</a>
            {{ $t('wohnlage.' + berechnung.selectedWohnlage) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/gebaeudetyp'" class="berechnungsLink">Geb&auml;udetypen:</a>
            {{ $t('gebaeudetyp.' + berechnung.selectedGebaeudetyp) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/haustyp'" class="berechnungsLink">Haustypen:</a>
            <div class="berechnungsContent" v-html="$t('haustyp.'+ berechnung.selectedHaustyp)"/>
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/heizung'" class="berechnungsLink">Unvollständige Beheizung:</a>
            <div class="berechnungsContent" v-html="$t('heizung.'+ berechnung.selectedUnvollstaendigBeheizung)"/>
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/fussbodenheizung'" class="berechnungsLink">Fu&szlig;bodenheizung:</a>
            {{ $t('fussbodenheizung.' + berechnung.selectedFussbodenheizung) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/sanitaerbereich'" class="berechnungsLink">Sanit&auml;rbereich:</a>
            <div class="berechnungsContent"
                 v-html="_translateList('sanitaerbereich.', berechnung.selectedSanitaerbereich)"/>
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/kueche'" class="berechnungsLink">Offene K&uuml;che:</a>
            {{ $t('kueche.' + berechnung.selectedKueche) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/kuechengrundausstattung'"
               class="berechnungsLink">K&uuml;chengrundausstattung:</a>
            {{ $t('kuechengrundausstattung.' + berechnung.selectedKuechengrundausstattung) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/elektrogeraete'" class="berechnungsLink">Elektroger&auml;te:</a>
            {{ _translateList('elektrogeraete.', berechnung.selectedElektrogeraete) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/fussboden'" class="berechnungsLink">Art des Fu&szlig;bodens:</a>
            {{ $t('fussboden.' + berechnung.selectedFussboden) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/modernisierterBoden'" class="berechnungsLink">Modernisierter Boden:</a>
            {{ $t('modernisierterBoden.' + berechnung.selectedModernisierterBoden) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/terrasseBalkon'" class="berechnungsLink">Terrasse/Dachterrasse/Balkon/Loggia:</a>
            {{ $t('terrasseBalkon.' + berechnung.selectedTerrasseBalkon) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/ausstattung'" class="berechnungsLink">Besondere Ausstattung:</a>
            {{ $t('besondereAusstattung.' + berechnung.selectedBesondereAusstattung) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/modernisierteFenster'" class="berechnungsLink">Modernisierte Fenster:</a>
            {{ $t('modernisierteFenster.' + berechnung.selectedModernisierteFenster) }}
          </li>
          <li class="berechnungsContent">
            <a :href="getBaseUrl() + '#/abweichungen'" class="berechnungsLink">Begr&uuml;ndete Abweichungen:</a>
            <span v-if="ergebnis.begruendeteAbweichungenTooHigh"
                  class='font-weight-bold red--text'>{{ ergebnis.begruendeteAbweichungenProQmTrue }} Euro/m²/Monat sind nicht zulässig wegen Überschreitung der Schwankungsbreite. Begründete Abweichungen werden auf den maximal zulässigen Wert von {{ ergebnis.schwankungObenProQm }} Euro/m²/Monat gekappt.</span>
            <span v-if="ergebnis.begruendeteAbweichungenTooLow"
                  class='font-weight-bold red--text'>{{ ergebnis.begruendeteAbweichungenProQmTrue }} Euro/m²/Monat sind nicht zulässig wegen Unterschreitung der Schwankungsbreite. Begründete Abweichungen werden auf den maximal zulässigen Wert von {{ ergebnis.schwankungUntenProQm }} Euro/m²/Monat gekappt.</span>
            {{ _translateAbweichung() }}
          </li>
        </ul>
        <br/>
        <h3 v-if="berechnung.selectedBetriebskostenA" class="berechnungsContent mt-3">
          <a :href="getBaseUrl() + '#/betriebskosten'" class="berechnungsLink">Betriebskosten:</a>
        </h3>
        <br/>
        <ul v-if="berechnung.selectedBetriebskostenA">
          <li
              v-for="(item, i) in berechnung.selectedBetriebskostenB"
              :key="i"
              class="berechnungsContent"
          >
            {{ $t('betriebskosten.' + item) }}<span v-if="item > 14">*</span>
          </li>
        </ul>
        <br/>
        <span v-if="berechnung.selectedBetriebskostenA && berechnung.selectedBetriebskostenB.some(e => e > 14)">
                    {{ $t('betriebskosten.footnote') }}
                </span>
      </div>

      <div class="ui-block-b" style="width:70%">
        <h3 class="berechnungsContent">Berechnungsergebnisse:</h3> <br/>
        <ul class="berechnungErgebnisse">
          <li class="berechnungsContent">
            Durchschnittliche orts&uuml;bliche Miete:<br/>
            {{ ergebnis.ortsueblicheMieteProQM }}
            Euro/m²/Monat<br/>
            {{ ergebnis.ortsueblicheMiete }}
            Euro/Monat
          </li>
          <li class="berechnungsContent">
            Durchschnittliche orts&uuml;bliche Miete mit Spanne nach unten:<br/>
            {{ ergebnis.ortsueblicheMieteSpanneUntenProQM }}
            Euro/m²/Monat<br/>
            {{ ergebnis.ortsueblicheMieteSpanneUnten }}
            Euro/Monat
          </li>
          <li class="berechnungsContent">
            Durchschnittliche orts&uuml;bliche Miete mit Spanne nach oben:<br/>
            {{ ergebnis.ortsueblicheMieteSpanneObenProQM }}
            Euro/m²/Monat<br/>
            {{ ergebnis.ortsueblicheMieteSpanneOben }}
            Euro/Monat
          </li>
          <li class="berechnungsContent">
            Durchschnittliche orts&uuml;bliche Miete mit begr&uuml;ndeten Abweichungen:<br/>
            {{ ergebnis.ortsueblicheMieteSpanneBegruendeteAbweichungenProQM }}
            Euro/m²/Monat<br/>
            {{ ergebnis.ortsueblicheMieteSpanneBegruendeteAbweichungen }}
            Euro/Monat
          </li>
        </ul>
        <br/>
        <h3 class="berechnungsContent">Adresse und Begründungen:</h3>
        <br/>
        <span class="berechnungsContent"><i>Hier können Sie die Adresse der Wohnung und - falls zutreffend - zusätzliche Begründungen für Abweichungen eingeben. Die Eingabe ist auf 500 Zeichen beziehungsweise 13 Zeilen beschränkt. (Die Angaben werden nicht gespeichert.)</i>
                </span>
        <br/>
        <div>
                <textarea class="zusaetzlicheBegruendungen"
                          v-model="zusaetzlicheBegruendungen"
                          reverse
                          label="Zusätzliche Begründungen"
                          :maxlength="500"
                >
                </textarea>
        </div>
        <v-checkbox
            v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" v-model="stichtagsdifferenzSelected"
            label="Stichtagsdifferenz"
        ></v-checkbox>
        <v-text-field v-if="stichtagsdifferenzSelected" v-model="stichtagsdifferenz.stand" reverse
                      label="Stand"></v-text-field>
        <v-text-field v-if="stichtagsdifferenzSelected" v-on:keypress="onlyNumber($event)"
                      v-model="stichtagsdifferenz.hoehe" reverse
                      label="Höhe der Stichtagsdifferenz in %"></v-text-field>
        <v-progress-circular v-if="rotate" indeterminate :rotate=rotate></v-progress-circular>
        <div class="d-flex justify-center my-3">
          <v-btn v-on:click="pdf" outlined large color="indigo" aria-labelled-by="Druckversion (PDF)"><span
              class="black--text subtitle-1">Druckversion (PDF)</span></v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<style>
@import '../mietspiegel.css';
</style>

<script>
import {Component, Vue} from 'vue-property-decorator';
import {EventBus} from '../eventbus';
import {createNamespacedHelpers, mapGetters} from 'vuex';
import Heizung from "@/views/Heizung.vue";

const {mapMutations} = createNamespacedHelpers('pdfparams')

@Component({
  components: {Heizung},
  computed: {
    ...mapGetters('user', ['hasPermission']),
    ...mapGetters('error', {errorExists: 'CALCULATION_HAS_ERROR'})
  },
  methods: {
    ...mapMutations(['SET_ZUSAETZLICHEBEGRUENDUNGEN']),
    ...mapMutations(['SET_STICHTAGSDIFFERENZ'])
  }
})
export default class Berechnungsergebnisse extends Vue {

  data() {
    return {
      index: 20,
      berechnung: this.$store.state.berechnung,
      ergebnis: this.$store.state.ergebnis,
      zusaetzlicheBegruendungen: this.$store.state.pdfparams.zusaetzlicheBegruendungen,
      backendUrl: this.$root.$children[0].$data.backendUrl,
      stichtagsdifferenz: {
        stand: this.$store.state.pdfparams.stichtagsdifferenz.stand,
        hoehe: this.$store.state.pdfparams.stichtagsdifferenz.hoehe
      },
      stichtagsdifferenzSelected: (this.$store.state.pdfparams.stichtagsdifferenz.stand != ''
              && this.$store.state.pdfparams.stichtagsdifferenz.stand != null)
          || (this.$store.state.pdfparams.stichtagsdifferenz.hoehe != ''
              && this.$store.state.pdfparams.stichtagsdifferenz.hoehe != 0),
      rotate: false
    };
  }

  get numHoehe() {
    return this.$data.stichtagsdifferenz.hoehe.replace(',', '.')
  }

  getBaseUrl() {
    if (window.location.href.includes("auth")) {
      return '/auth/index.html';
    }
    return '/berechnung.html'
  }

  mounted() {
    EventBus.$emit('berechnung', null);
    EventBus.$emit('scroll', this.$data.index)
    window.scrollTo(0, 0);
    //check if any previous page/category still has an error and prevent entering if so
    if (this.errorExists) {
      this.$router.go(-1)
    } else {
      this._callBerechnung().then(result => {
        console.log(result);
        EventBus.$emit('berechnung', result);
        this.$router.push('berechnungsergebnisse');
      });
    }
  }

  save() {
    this.SET_STICHTAGSDIFFERENZ(this.$data.stichtagsdifferenz)
    this.SET_ZUSAETZLICHEBEGRUENDUNGEN(this.$data.zusaetzlicheBegruendungen)
    EventBus.$emit('getSaveData', this.$data.index)
  }

  onlyNumber(event) {
    //console.log(event.keyCode);
    console.log(event);//keyCodes value
    let keyCode = (event.keyCode ? event.keyCode : event.which);
//          not necessary anymore ... different symbols e.g. 37 => %
//           if([8,46,37,39].includes(keyCode)){
    //allow del,backspace,arrows
//           }else{
    if (keyCode < 48 || keyCode > 57) {
      console.log("not a number")
      //TODO ? bug: minus can only be entered as the very first key - cannot be added to typed number
      if (!(keyCode == 45 && this.numHoehe.length < 1) // 45 is minus, 44 is comma, 46 is dot
          && !((keyCode == 44 || keyCode == 46) && this.numHoehe.length > 0
              && !this.numHoehe.includes('.') && !this.numHoehe.includes(','))) {
        event.preventDefault();
      }
    }
    /*
     * new key is not automatically concat at the end but can be inserted in another position
     * TODO ? bug: when having typed one number after the dot, one additional number permitted in every position
     * => possible to reach e.g. 9999.9
     */
    if (this.numHoehe.concat(event.key) > 999.99 || this.numHoehe.concat(event.key) < -999.99) {
      console.log("number too big/small")
      event.preventDefault();
    }
    //TODO ? bug: when already two numbers present after dot, even before the dot no keys can be added
    if (this.numHoehe.includes('.') && this.numHoehe.split('.')[1].length > 1) { // two numbers after dot
      console.log("precision too high")
      event.preventDefault();
    }
//           }
  }

  _translateList(key, list) {
    var result = '';
    if (list == null) {
      return result;
    }
    // TODO Sort list - Solution below way too slow
    //list = list.sort((n1,n2)=> n1 - n2);
    for (var i = 0; i < list.length; i++) {
      result += this.$t(key + list[i]);
      if (i + 1 < list.length) {
        result += ', '
      }
    }
    return result;
  }

  _translateAbweichung() {
    var result = '';
    var abweichungen = this.$data.berechnung.abweichungen;
    if (abweichungen.wasser != '') {
      result += this.$t('abweichungen.wasserBerechnung') + ' ' + abweichungen.wasser.toLocaleString('de-DE', {minimumFractionDigits: 2}) + ' Euro';
    }
    if (abweichungen.rueckgebaeude != '') {
      result = this._addSeperatorIfNotEmpty(result);
      result += this.$t('abweichungen.rueckgebaeudeBerechnung') + ' ' + abweichungen.rueckgebaeude.toLocaleString('de-DE', {minimumFractionDigits: 2}) + ' Euro';
    }
    if (abweichungen.waermedaemmung != '') {
      result = this._addSeperatorIfNotEmpty(result);
      result += this.$t('abweichungen.waermedaemmungBerechnung') + ' ' + abweichungen.waermedaemmung.toLocaleString('de-DE', {minimumFractionDigits: 2}) + ' Euro';
    }
    if (abweichungen.fassadeA != '') {
      result = this._addSeperatorIfNotEmpty(result);
      result += this.$t('abweichungen.fassadeBerechnung') + ' ' + abweichungen.fassadeA.toLocaleString('de-DE', {minimumFractionDigits: 2}) + ' Euro';
    } else if (abweichungen.fassadeB != '') {
      result = this._addSeperatorIfNotEmpty(result);
      result += this.$t('abweichungen.fassadeBerechnung') + ' ' + abweichungen.fassadeB.toLocaleString('de-DE', {minimumFractionDigits: 2}) + ' Euro';
    }
    if (abweichungen.zusatz != '') {
      result = this._addSeperatorIfNotEmpty(result);
      result += this.$t('abweichungen.zusatzBerechnung') + ' ' + abweichungen.zusatz.toLocaleString('de-DE', {minimumFractionDigits: 2}) + ' Euro';
    }
    if (result == '') {
      return this.$t('abweichungen.nein');
    }
    return result;
  }

  _addSeperatorIfNotEmpty(s) {
    if (s != '') {
      return s + ', ';
    }
    return s;
  }

  pdf() {
    console.log("Generate PDF")
    this._callPdf()
        .then(r => r.blob())
        .then(blob => {
          this.$data.rotate = false
          this._showFile(blob)
        });
  }

  // solution mostly from https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
  _showFile(blob) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([blob], {type: "application/pdf"})

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    var link = document.createElement('a');
    link.href = data;
    link.download = "Mietspiegel München.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  _callBerechnung() {
    const url = this.$data.backendUrl + `/api/backend-service/berechnung`;
    const data = JSON.stringify(this.$store.state.berechnung);
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: data
    }).then(res => {
      if (res.status == 404) {
        console.error(`Error: Endpoint not found`);
        return;
      }
      if (res.status != 200) {
        console.error(`error while calculating result with status:` + res.status);
        return;
      }
      //TODO json() producing an object of the returned object from the server !?
      return res.json();
    });
  }

  _callPdf() {
    this.$data.rotate = true
    const url = this.$data.backendUrl + `/api/backend-service/pdf`;
    let body;
    if (this.$data.stichtagsdifferenzSelected) {
      body = {
        berechnung: this.$store.state.berechnung, zusaetzlicheBegruendungen: this.$data.zusaetzlicheBegruendungen,
        stichtagsdifferenz: this.$data.stichtagsdifferenz
      }
    } else {
      body = {berechnung: this.$store.state.berechnung, zusaetzlicheBegruendungen: this.$data.zusaetzlicheBegruendungen}
    }
    const data = JSON.stringify(body);
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: data
    });
  }


  isEasterEgg() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!

    today = dd + '.' + mm
    return today === '01.04';
  }
}

</script>